import { FC, PropsWithChildren } from 'react';

import { Container, Content } from './styles';

const PublicLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Container>
      <Content>{children}</Content>
    </Container>
  );
};

export default PublicLayout;
